import { render, staticRenderFns } from "./terminologyTableForm.vue?vue&type=template&id=da7e9660"
import script from "./terminologyTableForm.vue?vue&type=script&lang=js"
export * from "./terminologyTableForm.vue?vue&type=script&lang=js"
import style0 from "./terminologyTableForm.vue?vue&type=style&index=0&id=da7e9660&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports